import { get, post } from '../../utils/axios'

export const listIncomeCertificateAPI = async (body) => {
  return await get('income/cer', body)
}
export const statusIncomeCertificateActiveAPI = async (body) => {
  return await get('income/cer/active/status', body)
}

export const seleteIncomeCertificateAPI = async (body) => {
  return await get('income/cer/select', body)
}

export const createIncomeCertificateAPI = async (body) => {
  return await post('income/cer', body)
}
export const updateIncomeCertificateAPI = async (body) => {
  return await post('income/cer/update', body)
}
export const deleteIncomeCertificateAPI = async (body) => {
  return await post('income/cer/delete', body)
}
